import { createRelayResource } from '@atlassian/jira-relay-utils/src/services/resources/index.tsx';
import GLOBAL_FILTERS_QUERY, {
	type menuNavigationAppsSidebarFiltersGlobalScopeQuery,
} from '@atlassian/jira-relay/src/__generated__/menuNavigationAppsSidebarFiltersGlobalScopeQuery.graphql';
import { fg } from '@atlassian/jira-feature-gating';
import { withGiraAggAnonSsrFix } from '../../../common/utils.tsx';

export const sidebarFiltersGlobalResource = withGiraAggAnonSsrFix(
	createRelayResource<menuNavigationAppsSidebarFiltersGlobalScopeQuery>({
		type: 'NAVIGATION_SIDEBAR_FILTERS_GLOBAL',
		getQuery: (_, { tenantContext }) => ({
			parameters: GLOBAL_FILTERS_QUERY,
			variables: {
				cloudId: tenantContext.cloudId,
				...(fg('add_limit_to_nav3_starred_filter_sidebar') && {
					first: 15,
				}),
			},
			options: { fetchPolicy: 'store-and-network' },
		}),
	}),
);
